import { Combinator } from 'modules/queryBuilder/types';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';

export const useCriteriaHeaderPretext = (combinator: Combinator) => {
  const { t } = useTranslation();
  switch (combinator) {
    case Combinator.AND:
      return t('storybook.layouts.criteria.criteriaPreheader.and');
    case Combinator.OR:
      return t('storybook.layouts.criteria.criteriaPreheader.or');
    case Combinator.NOT:
      return t('storybook.layouts.criteria.criteriaPreheader.not');
    default:
      return ''; // fn shouldn't hit this case
  }
};
